const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const signaturePatternActions = require('actions/signaturePattern');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { APIPost } = require('utilities/APIRequestHelper');
const actionTypes = require('constants/actionTypes');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { formatText } = require('core/i18n').i18n;
const { updateConsents } = require('actions/gdprConsents');
const { getCardStandard, getShippingAddressDetails, getCreditCardHiringStatus } = require('utilities/hireCardsHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
const { getCCOfficeChannel, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { API_CHANNEL, CREDIT_CARD_SUBTYPE_VISA, CREDIT_CARD_TYPE_VISA, HIRED_CARD_ACCEPTED } = require('constants/index');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { HIRE_BLOCKED } = require('constants/hireCardSubmitScenarios');
const {
  SECOND_STEP,
  THIRD_STEP
} = require('constants/index');
const resetWizard = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_RESET,

});
const setNewCreditCardData = (cardData) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_SET_DATA_CARD,
  payload: cardData,

});
const resetCheckbox = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_RESET_CHECKBOX,
});
const resetCreditCardDocumentsIneDir = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_RESET_DOCUMENTS_INE_DIR,
});
const hireNewCreditCardPrintDocument = (value) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_PRINT_DOCUMENT,
  payload: value,
});
const hireNewCreditCardCheckedRadioButton = (check) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_CHECK_RADIO_BUTTON,
  payload: check,
});
const validateLoading = (loadingFlag) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_LOADING,
  payload: loadingFlag,
});
const hireNewCreditCardFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});
const validate = (step, externalComponentsAreValid, isRevolving = false, ineDir) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_VALIDATE_STEP,
  payload: {
    step,
    valid: externalComponentsAreValid,
    isRevolving,
    ineDir
  },
});
const setVisibleStep = (step) => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_VISIBLE_STEP,
  payload: {
    step
  },
});

const setAccount = (accountId) => {
  return {
    type: actionTypes.HIRE_NEW_CREDIT_CARD_SET_ACCOUNT,
    payload: {
      accountId
    },
  };
};
const setWillCancel = (willCancel) => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_WILL_CANCEL,
  payload: {
    willCancel
  },
});
const validateAccount = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_VALIDATE_ACCOUNT,
});
const setShowModalStep2 = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_SHOW_MODAL,
});
const setCloseModalStep2 = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_CLOSE_MODAL,
});
const setCloseModal = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_CLOSE_MODAL,
});
const hireCreditCardDocumentRead = (documentType) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_DOCUMENT_READ,
  payload: {
    documentType
  }
})
const hireCreditCardAllDocumentRead = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_ALL_DOCUMENT_READ,
});
const hireCreditCardsaveDocumentAccepted = (documentsList, dmsDocumentType, documentChanges) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_SAVE_DOCUMENT_ACCEPTED,
  payload: { documentsList, dmsDocumentType, documentChanges }
})
const hireCreditCardCheckedRadioButtonIneDir = (documentsList, dmsDocumentType, documentChanges) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_CHECK_RADIO_BUTTON_INE_DIR,
  payload: { documentsList, dmsDocumentType, documentChanges }
})
const hireCreditCardCheckedRadioButton = (check) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_CHECK_RADIO_BUTTON,
  payload: { check }
})
const hireCreditCardPrintDocument = (value) => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_PRINT_DOCUMENT,
  payload: { value }
})
const hireNewCreditCardRequest = () => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_REQUEST,
});
const hireNewCreditCardSuccess = hiringStatus => ({
  type: actionTypes.HIRE_NEW_CREDIT_CARD_SUCCESS,
  payload: {
    hiringStatus,
  },
});
const onHandleChangeCheckBoxCC = () => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX_CC,
});

function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_AGREEINECHECKBOX,

  };
}
const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};
const agreeCheckboxCC = agreeCheckboxPaymentMethod => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_AGREECHECKBOXCC,
  payload: {
    agreeCheckboxPaymentMethod,
  },
});
function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CREDIT_PROCCESS_EMAIL_SUCCESS,
  };
}
function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CREDIT_PROCCESS_EMAIL_ERROR,
  };
}
const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};
const getNewCreditCardData = (cardData) => dispatch => {
  dispatch(setNewCreditCardData(cardData));
}
const setHireCreditCardLimit = () => dispatch => {
  dispatch(resetCheckbox());

  dispatch(hireCreditLimitActions.resetCreditCardCheckboxCC())
  if (isPrintOfficeMode()) {
    dispatch(resetPrintDocument());
  }
}
const validateFirstStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid');
  if (allComponentsAreValid) {
    dispatch(validate(step, false))
  }
};
const validateSecondStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));

    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid') && immHirePaymentMethod.get('valid');

    dispatch(validate(step, allComponentsAreValid));

    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {

    dispatch(validate(step, allComponentsAreValid));

  }
};

const validateINEDIRStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireNewCreditCard = getState().hireNewCreditCard;
  const documentINE = immHireNewCreditCard.get('initialDocumentsList');
  const documentINESize = documentINE.size < 2
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(validate(step, allComponentsAreValid, true));
    dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
    return documentINESize && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireNewCreditCard));
  } else {
    dispatch(validate(step, allComponentsAreValid, true));
    return documentINESize && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireNewCreditCard));
  }
};
const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const immHireNewCreditCard = getState().hireNewCreditCard;
  const documentId = immHireNewCreditCard.get('documentId')
  const operationProcessIdInit = immHireNewCreditCard.get('operationProcessIdInit')

  let acceptanceText;
  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    acceptanceText = 'NA'
  }
  if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
  }
  if (!__CONTACT_CENTER__) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
  }

  const documentIdDIR = immHireNewCreditCard.get('documentIdDIR')

  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      documents: [
        {
          documentId: immHireNewCreditCard.get('documentIdINE'),
          scrollDown: __CONTACT_CENTER__ ? false : true,
        },
        ...(documentIdDIR ? [{
          documentId: documentIdDIR,
          scrollDown: __CONTACT_CENTER__ ? false : true,
        }] : [])
      ],
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());
      }
    });
};
const getInitParams = () => (dispatch, getState) => {
  const immHireNewCreditCard = getState().hireNewCreditCard;

  const amount = getState().hireCreditLimit.get('creditLimit');
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const tae = getState().revolvingPersistentData.getIn(['paramsInne', 'tae']);
  const taeInit = getState().revolvingPersistentData.getIn(['paramsInne', 'taeInit']);
  const tin = getState().revolvingPersistentData.getIn(['paramsInne', 'tin']);
  const interestRate = Number(tin.replace(/%/g, '').replace(/,/g, '.')) / 100;

  const typePayment = getState().revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
  const calculationType = getState().revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
  const calculatePaymentMethod = getState().revolvingPersistentData.getIn(['paramsAFI', 'calculatePaymentMethod']);
  const fixedPaymentAmount = getState().revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
  const paymentMethodMap = { "FixedPaymentAmount": "FIXED", "PercentagePaymentRate": "VARIABLE" };
  const paymentMethod = paymentMethodMap[typePayment] || "UNIQUE";
  const calculationTypeMap = { 0: 0, 1: 1 };
  const mappedCalculationType = calculationTypeMap[calculationType] !== undefined ? calculationTypeMap[calculationType] : 3;
  const accountId = immHireNewCreditCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireNewCreditCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  const contractNumberAccountPolicy = immHireNewCreditCard.get('contractNumberAccount')
  const operationProcessIdInit = immHireNewCreditCard.get('operationProcessIdInit')

  const dataAfiSimulator = paymentMethod === "FIXED" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    fixedPaymentAmount
  } : paymentMethod === "VARIABLE" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    percentagePaymentRate: fixedPaymentAmount
  } : {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
  }
  return {
    query:
    {
      product: {
        type: productType,
        subtype: productSubType,
        standard: standard,
      },
      processType: "contract",
      dataAfiSimulator: dataAfiSimulator,
      tae: taeInit || tae,
      paymentMethod: calculatePaymentMethod ? calculatePaymentMethod : paymentMethod,
      amount: amount,
      contractNumberAccount: (contractNumberAccountPolicy ?? contractNumberAccount),
      attachedEvidences: [operationProcessIdInit
      ]

    }
  }
}
const validatePolicyStep = () => (dispatch, getState) => {
  const immHireNewCreditCard = getState().hireNewCreditCard;
  const documentPolicy = immHireNewCreditCard.get('documentPolicy')
  const paramsInit = dispatch(getInitParams());

  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireNewCreditCard, false, paramsInit));
};

const validateFourthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));

    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));

    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {

    dispatch(validate(step, allComponentsAreValid));

  }
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireNewCreditCard.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateStepOne = (dispatch, getState, step) => {
  dispatch(hireCreditLimitActions.validateStep());
  dispatch(hirePaymentMethodActions.validateStep());
  dispatch(validateFirstStep(step));
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const type = immHirePaymentMethod.get('type');
  const value = immHirePaymentMethod.get('value');
  const initialType = immHirePaymentMethod.get('initialType');
  const initialValue = immHirePaymentMethod.get('initialValue');
  if (type !== initialType || value !== initialValue) {
    dispatch(hirePaymentMethodActions.setInitialType(type));
    dispatch(hirePaymentMethodActions.setInitialValue(value));
    dispatch(hireCardCreditINE.getInitCardsDocuments());
    dispatch(resetCreditCardDocumentsIneDir());
  }

};

const validateStepTwo = (dispatch, getState, step) => {
  dispatch(resetPrintDocument());
  dispatch(validateAccount());
  dispatch(hireContactDataActions.validateStep(false));
  const immHireContactData = getState().hireContactData;
  const accountIsValid = getState().hireNewCreditCard.getIn(['steps', step - 1, 'accountIsValid']);
  const showModal = getState().hireNewCreditCard.get('showModal');
  const closeModal = getState().hireNewCreditCard.get('closeModal');
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
    !showModal && !closeModal && dispatch(setShowModalStep2());
    if (showModal && !closeModal && accountIsValid) {
      dispatch(validateSecondStep(step));
      dispatch(setCloseModalStep2());
      if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
        dispatch(validateINEDIRStep(step)).then(() => {
          dispatch(validatePolicyStep());
        });
      } else {
        dispatch(validateINEDIRStep(step));
      }
    }
  } else {
    dispatch(validateSecondStep(step));
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
      dispatch(validateINEDIRStep(step)).then(() => {
        dispatch(validatePolicyStep());
      });
    } else {
      dispatch(validateINEDIRStep(step));
    }
  }

};

const validateStepThree = (dispatch, getState, step) => {
  const policyDocument = getState().hireNewCreditCard.get('documentPolicy');
  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    dispatch(validatePolicyStep());
  } else {
    !policyDocument && dispatch(processEmail()).then(() => {
      dispatch(validatePolicyStep());
    });
  }

  dispatch(validateFourthStep(step));
  !isPrintOfficeMode() && dispatch(agreeIneCheckbox());
};

const validateStepFour = (dispatch, getState, step) => {
  dispatch(validate(step, false));
};


const validateStep = step => (dispatch, getState) => {
  if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
    switch (step) {
      case 1:
        dispatch(validate(step, false));
        break;
      case 2:
        validateStepOne(dispatch, getState, step);
        break;
      case 3:
        validateStepTwo(dispatch, getState, step);
        break;
      case 4:
        validateStepThree(dispatch, getState, step);
        break;
      case 5:
        validateStepFour(dispatch, getState, step);
        break;
      case 6:
        dispatch(validate(step, false));
        break;
      default:
        break;
    }
  } else if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    switch (step) {
      case 1:
        dispatch(validate(step, false));
        break;
      case 2:
        validateStepOne(dispatch, getState, step);
        break;
      case 3:
        validateStepTwo(dispatch, getState, step);
        break;
      case 4:
        validateStepFour(dispatch, getState, step);
        break;
      case 5:
        dispatch(validate(step, false));
        break;
      default:
        break;
    }
  } else {
    switch (step) {
      case 1:
        validateStepOne(dispatch, getState, step);
        break;
      case 2:
        validateStepTwo(dispatch, getState, step);
        break;
      case 3:
        validateStepThree(dispatch, getState, step);
        break;
      case 4:
        validateStepFour(dispatch, getState, step);
        break;
      case 5:
        dispatch(validate(step, false));
        break;
      default:
        break;
    }
  }

  return dispatch(getStep(step));
};
const getHiring = (productType, productSubType, referenceStandard, defaultLimit) => (dispatch, getState) => {
  const immCards = getState().cards;
  const immCardById = immCards && immCards.get('byId');
  const immCardByOrder = immCards && immCards.get('byOrder');

  const cardObj =
    immCardByOrder &&
    immCardByOrder.map(cardId => {
      const immCard = immCardById && immCardById.get(cardId);
      return {
        contractNumber: immCard.getIn(['contract', 'number']),
        pan: immCard.get('number'),
        product: immCard.get('newProduct'),
        subType: immCard.get('productSubType'),
        standard: immCard.getIn(['product', 'standard']),
      };
    });
  dispatch(validateLoading(true));
  return APIPost({
    dispatch,
    endpoint: 'validateCardHire',
    params: {
      query: { cards: cardObj },
    },
  })
    .then(() => {
      dispatch(validateLoading(false));
      dispatch(hireCreditLimitActions.getHireCreditLimit(productType, productSubType, referenceStandard, defaultLimit, true));

    })
    .catch(error => {
      if (error) {
        if (error.error.status === 412 && error.body.error === HIRE_BLOCKED) {
          dispatch(hireNewCreditCardFailure(HIRE_BLOCKED));
          dispatch(validateLoading(false));
        } else {
          dispatch(hireNewCreditCardFailure());
          dispatch(validateLoading(false));
        }
      }
    });




};
const resetPrintDocument = () => dispatch => {
  dispatch(hireNewCreditCardPrintDocument(false));
}
const documentRead = (documentType) => (dispatch, getState) => {

  dispatch(hireCreditCardDocumentRead(documentType));
};
const onAcceptAllDocument = () => (dispatch, getState) => {
  dispatch(hireCreditCardAllDocumentRead());
};
const saveDocumentList = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCreditCardsaveDocumentAccepted(documentsList, dmsDocumentType, documentChanges));
};
const checkRadioButtonIneDir = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCreditCardCheckedRadioButtonIneDir(documentsList, dmsDocumentType, documentChanges));
}
const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCreditCardCheckedRadioButton(check));
}
const printDocument = () => (dispatch, getState) => {
  dispatch(hireCreditCardPrintDocument(true));
}
const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireNewCreditCardRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireNewCreditCardFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireNewCreditCardSuccess(status.hiringStatus));
        if (HIRED_CARD_ACCEPTED.includes(response.estado.id)) {
          const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
          if (showIneAndRevolving && contractNumber) {
            dispatch(
              setTermsAndCondsInfoRevolving(
                OPEN_CREDIT_CARD_PRODUCT_ALIAS,
                termsAndsCondsHiringData,
                contractNumber
              )
            );
          } else {
            dispatch(setTermsAndCondsInfo(OPEN_CREDIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
          }
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireNewCreditCardFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireNewCreditCardFailure());
      } else {
        throw response;
      }
    });
};
const setHireCreditCard = (
  dispatch,
  data,
  productAlias,
  termsAndsCondsHiringData,
  showIneAndRevolving
) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireNewCreditCardRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireNewCreditCardFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireNewCreditCardSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(productAlias, termsAndsCondsHiringData, contractNumber)
          );
        } else {
          dispatch(setTermsAndCondsInfo(productAlias, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireNewCreditCardFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireNewCreditCardFailure());
      } else {
        throw response;
      }
    });
};
const myCardsTarjetasHire = () => (dispatch, getState) => {
  const immHireNewCreditCard = getState().hireNewCreditCard;
  const callback = (dispatch, getState, dataToken) => {
    const contractNumberAccount = immHireNewCreditCard.get('contractNumberAccount')
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const standard = immHireNewCreditCard.get('standard')
    const subTipo = immHireNewCreditCard.get('subtype')
    const tipo = immHireNewCreditCard.get('type')

    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA'
      : __CONTACT_CENTER__ && isPrintOfficeMode() ? formatText('hireCardOpenCreditStepPolicy-titlePdfWP')
        : formatText('hireCreditCard-textInfoIneDir')
    const limiteSolicitadoNumber = parseInt(immCreditLimit.get('creditLimit'), 10);

    const data = {
      processType: 'contract',
      documentId: immHireNewCreditCard.get('documentIdPolicy'),
      operationProcessId: immHireNewCreditCard.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: limiteSolicitadoNumber,
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard,
          subTipo,
          tipo,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: immHireNewCreditCard.get('scrollDownPolicy'),

    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_VISA,
        type: CREDIT_CARD_TYPE_VISA,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setHireCreditCard(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  reset,
  getNewCreditCardData,
  setHireCreditCardLimit,
  validateStep,
  getHiring,
  resetPrintDocument,
  validate,
  setVisibleStep,
  setAccount,
  setWillCancel,
  setCloseModal,
  documentRead,
  onAcceptAllDocument,
  saveDocumentList,
  checkRadioButtonIneDir,
  checkRadioButton,
  printDocument,
  myCardsTarjetasHire,
  agreeCheckboxCC,
  processEmail,
  onHandleChangeCheckBoxCC,
  setAgreementCheckbox
};
